//全局input输入数值限制
function onInput(el:any, ele:any, binding:any, vnode:any) {
  function handle() {
    let val = ele.value;
    const oldValue = ele.value;
    // modifiers为修饰符对象，传入了float，则其float属性为true
    if (binding.modifiers.float) {
      // 清除"数字"和"."以及"-"以外的字符
      val = val.replace(/[^\-\d.]/g, "");
      // 只保留第一个'-'号
      val = val.replace(/\.{2,}/g, ".").replace(/-{2,}/g, "-");
      // 将 '-.' 替换成 '-0.'
      val = val.replace(/^\./g, "0.").replace(/^-\./, "-0.");
      if (typeof binding.value !== "undefined") {
        // 期望保留的最大小数位数
        let pointKeep = 0;
        if (typeof binding.value === "string" || typeof binding.value === "number") {
          pointKeep = parseInt(binding.value);
        } else if (typeof binding.value === "object") {
          // 支持新的小数点保留位配置
          pointKeep = binding.value.decimal;
        }
        if (!isNaN(pointKeep)) {
          if (!Number.isInteger(pointKeep) || pointKeep < 0) {
            pointKeep = 0;
          }
          // 增加'-'号的支持
          const str = "^(\\-)*(\\d+)\\.(\\d{" + pointKeep + "}).*$";
          const reg = new RegExp(str);
          if (pointKeep === 0) {
            // 不需要小数点
            val = val.replace(reg, "$1$2");
          } else {
            // 通过正则保留小数点后指定的位数
            val = val.replace(reg, "$1$2.$3");
          }
        }
      } else {
        val = ele.value.replace(/[^\d]/g, "");
      }
      if (val !== "" && typeof binding.value === "object") {
        let { min, max } = binding.value;
        min = parseFloat(min);
        max = parseFloat(max);
        if (!isNaN(min)) {
          if (min >= 0) {
            // 不能是负数
            val = val.replace("-", "");
          }
          if (parseFloat(val) < min) {
            val = min;
          }
        }
        if (!isNaN(max)) {
          if (parseFloat(val) > max) {
            val = max;
          }
        }
      }
      // console.log(val, "val", oldValue, vnode.componentInstance);
      if (vnode.componentInstance) {
        vnode.componentInstance.$emit("input", ele.value);
      } else {
        //输入符号“-”时比较要按string来做处理，不能专为number
        if (!val.includes("-")) {
          if (+val !== +oldValue) {
            ele.value = val;
            ele.dispatchEvent(new Event("input"));
          }
        } else {
          if (val !== oldValue) {
            ele.value = val;
            ele.dispatchEvent(new Event("input"));
          }
        }
      }
    }
  }
  return handle;
}
const vNumberInput = {
  mounted(el:any, binding:any, vnode:any) {
    const ele = el.tagName === "INPUT" ? el : el.querySelector("input");
    ele.addEventListener("input", onInput(el, ele, binding, vnode), false);
  },
};
export default vNumberInput;
